const objectUser = {
    id: 0,
    email: "",
    first_name: "",
    last_name: "",
    telephone_number: "",
    avatar : "",
    address : [],
    password:'',
    password_confirmation:'',
    token:''
}
export default Object(objectUser);